import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridSizeType } from '@/shared';

export type SingleIconButtonProps = {
  label?: string;
  onClick?: () => void;
  startIcon: React.ReactNode;

  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'inherit'
    | 'success'
    | 'info'
    | 'warning'
    | 'black';

  // new
  newCustomButton?: boolean;
  variant?: 'text' | 'outlined' | 'contained' | undefined;
  size?: GridSizeType;

  noThemeColor?: boolean;
  disabled?: boolean;
};

const SingleIconButton: React.FC<SingleIconButtonProps> = ({
  startIcon,
  color = 'primary',
  label,
  onClick,
  size,
  noThemeColor = false,
  disabled = false,
}) => {
  return (
    <>
      <Grid item {...size}>
        <Tooltip title={label}>
          <IconButton
            color={disabled ? ('disabled' as any) : color}
            onClick={() => {
              if (disabled) return;

              onClick && onClick();
            }}
            className={
              noThemeColor
                ? 'table__icon-button--no-color'
                : disabled
                ? 'table__icon-button--disabled'
                : ''
            }
          >
            {startIcon}
          </IconButton>
        </Tooltip>
      </Grid>
    </>
  );
};

export default SingleIconButton;
